var PalabrasDescendentes = function(el, datos, total, callback) {
  var debug = false;

  var altoVisualizacion = 0;
  var escalaTamanio = null;
  var alturaMaxima = null;

  var aux = {
    top: 70,
    right: 20,
    bottom: 20,
    left: 20
  };

  (function() {
    datos.opciones = _.filter(datos.opciones, function(d) {
      return d.valor > 0;
    });
    datos.opciones.sort(ordenaOpcion);
    total = datos.hasOwnProperty("total") ? datos.total : total;
    var config = new Config(0, aux);
    var contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      var palabras = config.getPalabras();
      var valores = _.map(datos.opciones, "valor");
      var dominio = [0, 100];
      var rango = [palabras.tamanio.min, palabras.tamanio.max];
      escalaTamanio = d3.scale
        .linear()
        .domain(dominio)
        .range(rango);
      var svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", "0 0 " + config.getAncho() + " " + 0);
      var textos = svg.selectAll("text").data(datos.opciones, function(d) {
        return d.opcion;
      });
      textos
        .enter()
        .append("text")
        .text(function(d) {
          return d.valor;
        })
        .style("font-size", function(d) {
          return escalaTamanio(d.valor) + "px";
        })
        .each(function(d) {
          var caja = d3
            .select(this)
            .node()
            .getBBox();
          alturaMaxima = _.max([alturaMaxima, caja.height]);
        });
      altoVisualizacion = alturaMaxima;
      altoVisualizacion +=
        (datos.opciones.length - 1) * palabras.distanciaVertical;
      var margin = config.getMargin();
      var gMargin = config.getGMargin();
      altoVisualizacion +=
        margin.top + margin.bottom + gMargin.top + gMargin.bottom;
      svg.remove();
    }
  })();

  var config = new Config(altoVisualizacion, aux);

  var margin = config.getMargin();
  var medidas = config.getMedidas();

  var gMargin = config.getGMargin();
  var gMedidas = config.getGMedidas();

  var estilos = config.getEstilos();
  var circulos = config.getCirculos();

  var contenedor = null;
  var svg = null;
  var gGrafica = null;

  var grupos = null;

  function setup() {
    contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      el.data("visualizacion", true);
      contenedor.selectAll("svg").remove();
      svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr(
          "viewBox",
          "0 0 " +
            (medidas.ancho + margin.left + margin.right) +
            " " +
            (medidas.alto + margin.top + margin.bottom)
        );

      el.attr("data-setup", true);

      if (debug === true) {
        svg
          .append("rect")
          .attr("fill", "yellow")
          .attr("opacity", 0.5)
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", medidas.ancho + margin.left + margin.right)
          .attr("height", medidas.alto + margin.top + margin.bottom);
      }

      svg = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      if (debug === true) {
        svg
          .attr("class", "svg")
          .append("rect")
          .attr("width", medidas.ancho + (margin.right - margin.left))
          .attr("height", medidas.alto)
          .attr("fill", "blue")
          .attr("opacity", 0.5);
      }

      gGrafica = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + gMargin.left + "," + gMargin.top + ")"
        );

      if (debug === true) {
        gGrafica
          .attr("class", "gGrafica")
          .append("rect")
          .attr("width", gMedidas.ancho)
          .attr("height", gMedidas.alto)
          .attr("fill", "red")
          .attr("opacity", 0.5);
      }

      var pcts = funciones.getPorcentajes(
        _.map(datos.opciones, "valor"),
        total
      );

      _.each(pcts, function(p, i) {
        datos.opciones[i].valor = pcts[i];
      });

      datos.opciones = _.orderBy(
        datos.opciones,
        ["valor", "etiqueta"],
        ["desc", "asc"]
      );

      main();
    }
  }

  function main() {
    setLeyendas();
    setPalabras();
    funciones.generaTooltips(gGrafica.selectAll("path.transporte"));
    el.removeClass("espera");
    iniciar();
  }

  function revisaScroll() {
    if (el.visible() === true) {
      iniciar();
      $(window).off("scroll", revisaScroll);
    }
  }

  function iniciar() {
    actualizaPalabras();
    callback(null, true);
  }

  function setPalabras() {
    var palabras = config.getPalabras();
    grupos = gGrafica
      .selectAll("g.palabra")
      .data(datos.opciones, function(d) {
        return d.opcion;
      })
      .enter()
      .append("g")
      .attr("class", "palabra")
      .attr("transform", function(d, i) {
        return (
          "translate(0," + (alturaMaxima + palabras.distanciaVertical * i) + ")"
        );
      });

    var textos = grupos
      .append("text")
      .attr("class", "etiqueta")
      .style(palabras.estiloEtiqueta)
      .style("font-size", function(d) {
        return escalaTamanio(d.valor) * 0.8 + "px";
      });

    textos.append("tspan").text(function(d) {
      return d.etiqueta;
    });
  }

  function actualizaPalabras() {
    var palabras = config.getPalabras();
    var prefijo = el.data("prefijo") || "";
    var unidad = el.data("unidad") || "";

    grupos
      .selectAll("text.etiqueta")
      .append("tspan")
      .attr("class", "valor")
      .style(palabras.estiloValor)
      .style("font-size", function(d) {
        return escalaTamanio(d.valor) + "px";
      })
      .text(function(d) {
        return " " + prefijo + d.valor + unidad;
      })
      .attr("opacity", 0)
      .transition()
      .duration(800)
      .attr("opacity", 1);
  }

  function setLeyendas() {
    var titulo = datos.titulo || false;
    if (titulo !== false) {
      svg
        .append("text")
        .style(estilos.titulo)
        .attr("x", 0)
        .attr("y", margin.top)
        .text(titulo);
    }
  }

  function ordenaOpcion(a, b) {
    if (a.valor < b.valor) {
      return 1;
    }
    if (a.valor > b.valor) {
      return -1;
    }
    return 0;
  }

  setup();
};
